import { noop } from 'lodash'

// Note: Also respond to touchstart so works on iOS Safari
// Note: addEventListener doesn't add multiple listeners, yay!
export function addBodyTapListener(callback) {
  // TODO: Modify to use the addTapListener function
  document.body.addEventListener('click', callback)
  document.body.addEventListener('touchend', callback)
}

export function removeBodyTapListener(callback) {
  // TODO: Modify to use the removeTapListener function
  document.body.removeEventListener('click', callback)
  document.body.removeEventListener('touchend', callback)
}

export function addTapListener(element, callback = noop) {
  if (element) {
    element.addEventListener('click', callback)
    element.addEventListener('touchend', callback)
  }
}

export function removeTapListener(element, callback = noop) {
  if (element) {
    element.removeEventListener('click', callback)
    element.removeEventListener('touchend', callback)
  }
}
